module.exports = __webpack_public_path__ + "public/files/img/bell.afec951c.gif";